import WhitelabelBanner from './whiteLabelBanner.ui';

export default WhitelabelBanner;
